import { RefreshCw } from 'lucide-react'
import { Button } from './Button.js'

interface LoadFailureProps {
  /** What could not be loaded, in the reader's words. */
  message: string
  /** Asks again: usually the query's `refetch`. */
  onRetry: () => void
  /** True while the retry is in flight, so the button cannot be pressed twice. */
  retrying?: boolean
  /** The text size of the surrounding screen. */
  size?: 'xs' | 'sm'
  /** Padding and layout of the surrounding screen; the message and button are laid out inside it. */
  className?: string
}

/**
 * A load that failed, with a way to ask again right there (the user's rule,
 * 16 October 2026): every "could not be loaded" in the app carries a Try
 * again button rather than telling the reader to come back later.
 */
export function LoadFailure({ message, onRetry, retrying = false, size = 'sm', className = '' }: LoadFailureProps) {
  return (
    <div role="alert" className={`flex flex-wrap items-center gap-x-3 gap-y-2 ${size === 'xs' ? 'text-[11px]' : 'text-sm'} text-coral ${className}`}>
      <span>{message}</span>
      <Button icon={RefreshCw} variant="secondary" size="sm" disabled={retrying} onClick={onRetry}>
        {retrying ? 'Trying…' : 'Try again'}
      </Button>
    </div>
  )
}
